import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'The London Rubber Company was founded by LA Jackson, selling imported condoms and barber shop supplies.',
		},
		{
			year: 1929,
			description: 'The London Rubber Company (LRC) registers Durex brand.',
		},
		{
			year: '1950',
			description: 'Durex release its first lubricated condom',
		},
		{
			year: 1953,
			description: 'Durex is the first brand to develop and use electronic testing',
		},
		{
			year: '1960',
			description: 'The world\'s first anatomically shaped condom is released by Durex',
		},
		{
			year: '1970',
			description: 'Durex is the world\'s first condom brand to advertise in many countries',
		},
		{
			year: '1990',
			description: 'Durex is the first condom brand to adopt a Global "seal of quality" as standard',
		},
		{
			year: 1995,
			description: 'Durex introduces a range of colored and flavoured condoms',
		},
		{
			year: 1996,
			description: 'Durex is the first condom brand to launch a website.Now we have 42 different sites for the countries we market in.',
		},
		{
			year: 1997,
			description: 'Durex introduces non-latex condoms: The Avanti Range, which uses a new non-allergenic material - synthetic polyurethane developed by Durex that is softer and more elastic than natural rubber latex in.',
		},
		{
			year: 1998,
			description: 'Durex is the first condom company to conduct and publish a global survey.',
		},
		{
			year: 2001,
			description: 'Durex introduces Pleasuremax: The ultimate pleasure condom for both partners, making Durex the first condom brand  to market a condom that combines ribbed and dotted textures with shape, to maximize simulation for both partners',
		},
		{
			year: 2002,
			description: 'Durex supports groundbreaking social program to promote gender equity in Brazil \'Program H\' <br>This is followed by further projects in India.',
		},
		{
			year: 2003,
			description: 'Durex launches an exciting range of Play® lubricants',
		},
		{
			year: 2005,
			description: 'Durex Network launches the Face of Global Sex reports that explore the aspects of human sexual behavior and are produced primarily to inform academics and policy',
		},
		{
			year: 2008,
			description: 'To promote safe sex for young people, Durex called for young people between the ages of 16-24 to design a unique sexual health poster - a poster designed by them, for them',
		},
		{
			year: 2009,
			description: 'Durex turns 80!',
		},
		{
			year: 2010,
			description: 'Durex supported the Condomize! initiative of The United Nations Populations Fund, at the International AIDS Conference in Vienna by donating 220,000 condoms.',
		},
	]
}